import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from "classnames";
import { useEffect, useRef } from "react";
import { SVGQuote } from "@icons/SVGQuote";
import Button from "@components/button/Button";
import WidgetWrapper from "@components/wrapper/WidgetWrapper";
import { useWindow } from "@hooks/useWindow";
const QuoteCardWidget = ({ bottomMargin, topMargin, widgetID, data: { heading, subHeading, quoteText, imageAltText, imageURL, authorsJobTitle, quotesAuthor, button, enlargeQuoteText } }) => {
    const quoteCardRef = useRef(null);
    const myWindow = useWindow();
    const setButtonWidth = () => {
        var _a, _b;
        const cardWidth = (_a = quoteCardRef === null || quoteCardRef === void 0 ? void 0 : quoteCardRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        const cardWidthButtonBreakpoint = 705;
        const btnWrapper = (_b = quoteCardRef === null || quoteCardRef === void 0 ? void 0 : quoteCardRef.current) === null || _b === void 0 ? void 0 : _b.querySelector(".quote-card-content-btn-wrapper > *");
        if (cardWidth > cardWidthButtonBreakpoint) {
            if (btnWrapper) {
                btnWrapper.style.width = `fit-content`;
            }
        }
        else if (btnWrapper) {
            btnWrapper.style.width = `100%`;
        }
    };
    useEffect(() => {
        if (quoteCardRef.current) {
            setButtonWidth();
        }
    }, [quoteCardRef]);
    useEffect(() => {
        const sub = myWindow ? myWindow.addEventListener("resize", setButtonWidth) : null;
        return () => sub;
    }, [myWindow]);
    return (_jsx(WidgetWrapper, { id: widgetID, bottomMargin: bottomMargin, topMargin: topMargin, children: _jsxs("article", { ref: quoteCardRef, className: "quote-card", children: [imageURL && (_jsx("div", { className: "quote-card-image", children: _jsx("img", { className: "quote-card-img", src: imageURL, alt: imageAltText }) })), _jsxs("div", { className: "quote-card-content", children: [heading && _jsx("h3", { className: "quote-card-content__title", children: heading }), subHeading && _jsx("div", { className: "quote-card-content__subtitle", dangerouslySetInnerHTML: { __html: subHeading } }), quoteText && (_jsxs("div", { className: "quote-card-content__quote", children: [_jsx(SVGQuote, { className: "quote-card-content__quote-icon" }), _jsx("div", { className: cn("quote-card-content__quote-text", enlargeQuoteText && "quote-card-content__quote-text--lg"), dangerouslySetInnerHTML: { __html: quoteText } })] })), (quotesAuthor || authorsJobTitle) && (_jsxs("address", { className: "quote-card-content__author", children: [quotesAuthor && _jsx("span", { children: quotesAuthor }), authorsJobTitle && _jsx("span", { children: authorsJobTitle })] })), button.url && button.title && (_jsx("div", { className: "quote-card-content-btn-wrapper", children: _jsx(Button, { link: button.url, title: button.title, type: "primary" }) }))] })] }) }));
};
export default QuoteCardWidget;
